import os from "os";
import path from "path";
import fs from "fs";
import { RepairRule } from "../repairEngine.js";
import { findPackageJson, directoryExists } from "../../utils/files.js";
import { runCommand } from "../../utils/exec.js";

export const podInstallRepairRules: RepairRule[] = [
  {
    id: "ios-pods-install",
    title: "Regenerate iOS CocoaPods Dependencies",
    description: "Runs 'pod install' in the ios directory if the Podfile exists but Pods directory is missing.",
    safe: false,
    async detect(cwd: string): Promise<boolean> {
      if (os.platform() !== "darwin") return false;
      const pPath = findPackageJson(cwd);
      if (!pPath) return false;
      const root = path.dirname(pPath);
      const iosPath = path.join(root, "ios");
      const podfilePath = path.join(iosPath, "Podfile");
      const podsPath = path.join(iosPath, "Pods");
      return fs.existsSync(podfilePath) && !directoryExists(podsPath);
    },
    async repair(cwd: string): Promise<{ success: boolean; details?: string }> {
      const pPath = findPackageJson(cwd);
      if (!pPath) return { success: false, details: "package.json not found." };
      const root = path.dirname(pPath);
      const iosPath = path.join(root, "ios");

      const podCheck = await runCommand("pod --version");
      if (podCheck.error) {
        return { success: false, details: "CocoaPods 'pod' command not found in your PATH." };
      }

      const result = await runCommand(`cd "${iosPath}" && pod install`);
      if (result.error) {
        return {
          success: false,
          details: `CocoaPods installation failed: ${result.stderr || result.stdout}`,
        };
      }
      return { success: true, details: "CocoaPods generated successfully." };
    },
  },
];
